<template>
<div class="instance-pic-wrapper" @mousewheel.stop>
  <div v-if="oneImg" class="file-img">
    <div class="file-img-png">
      <div @mousewheel="handleZoomImg" @mousedown="move"
        class="image-preview-one"
        :style="{backgroundImage: 'url(' + imgOss + oneUrl + ')', 
        scale: zoomIndex / 10 * 1,
        backgroundSize:'contain',
        backgroundPosition:'center',
        backgroundRepeat: 'no-repeat'}">
      </div>
    </div>
    <div class="rotate-btns">
      <el-button size="mini" @click="leftRotatePic">左旋转</el-button>
      <el-button size="mini" @click="rightRotatePic">右旋转</el-button>
    </div>
  </div>
  <div v-else class="instance-img">
    <el-carousel ref="carouselRef" :interval="3000" arrow="always" indicator-position="none" :autoplay="false" :loop="false" @change="changeImg">
      <el-carousel-item v-for="(item,index) in otherList" :key="index">
        <div 
          v-if="item.url"
          :class="['image-preview-mouse',`multi-mouse${loadIndex}`]"
          @mousedown="move"
          @mousewheel.stop="handleZoomImg"
          :key="index"
          :style="{backgroundImage: item.url.indexOf('aliyuncs.com') == -1 ? 'url(' + imgOss + item.url + ')' : 'url(' + item.url + ')', 
          scale: zoomIndex / 10 * 1,
          backgroundSize:'contain',
          backgroundPosition:'center',
          backgroundRepeat: 'no-repeat'}">
        </div>
        <div v-else :class="['no-img',`multi-mouse${loadIndex}`]">
          暂无图片
        </div>
      </el-carousel-item>
    </el-carousel>
    <div v-show="otherList[defaultAddImgIndex].url" class="rotate-btns">
      <el-button size="mini" @click="leftRotateInstance">左旋转</el-button>
      <el-button size="mini" @click="rightRotateInstance">右旋转</el-button>
      <slot name="button"></slot>
    </div>
  </div>
</div>
</template>
<script>
// import { getPatientFocusFieldPage,disableInvalid,readOtherEntry,markFocus } from "@/api/crossreentry"
export default {
  props: {
    oneImg: {
      type: Boolean,
      default: false
    },
    loadIndex:{
      type:Number,
      default: 0
    },
    otherList:{
      type:Array,
      default:()=>[]
    },
    oneUrl: {
      type:String
    },
    defaultIndex:{
      type:Number,
      default: 0
    },
  },
  data() {
    return {
      imgOss: process.env.VUE_APP_OSS_URL, //图片公用拼接地址
      zoomIndex: 10,
      rotateCountDeg: 0,
      defaultAddImgIndex: 0
    }
  },
  async created() {
    this.defaultAddImgIndex = this.defaultIndex
  },
  mounted() {
    if (!this.oneImg) {
      this.$nextTick(() => {
        // console.log(this.defaultIndex)
        this.$refs.carouselRef.setActiveItem(this.defaultIndex);
      })
    }
    // console.log(this.otherList)
  },
  methods: {
    leftRotateInstance() {
      // console.log(document.getElementsByClassName("image-preview-mouse"))
      let selectImgNode = document.getElementsByClassName(`multi-mouse${this.loadIndex}`)[this.defaultAddImgIndex]
      // console.log(selectImgNode)
      this.rotateCountDeg = this.rotateCountDeg - 90
      selectImgNode.style.rotate = this.rotateCountDeg + 'deg'
    },
    rightRotateInstance() {
      // let selectImgNode = document.getElementById(`multi-mouse${this.loadIndex}`)[this.defaultAddImgIndex]
      let selectImgNode = document.getElementsByClassName(`multi-mouse${this.loadIndex}`)[this.defaultAddImgIndex]
      console.log(selectImgNode)
      this.rotateCountDeg = this.rotateCountDeg + 90
      selectImgNode.style.rotate = this.rotateCountDeg + 'deg'
    },
    leftRotatePic() {
      let selectImgNode = document.getElementsByClassName("image-preview-one")[0]
      console.log(selectImgNode)
      this.rotateCountDeg = this.rotateCountDeg - 90
      selectImgNode.style.rotate = this.rotateCountDeg + 'deg'
    },
    rightRotatePic() {
      let selectImgNode = document.getElementsByClassName("image-preview-one")[0]
      console.log(selectImgNode)
      this.rotateCountDeg = this.rotateCountDeg + 90
      selectImgNode.style.rotate = this.rotateCountDeg + 'deg'
    },
    changeImg(index,oldImgIndex) {
      this.zoomIndex = 10
      this.rotateCountDeg = 0
      console.log(index)
      let selectOldImgNode = document.getElementsByClassName("image-preview-mouse")[oldImgIndex]
      if (selectOldImgNode) {
        setTimeout(() => {
          // 重置上张切换的图片
          selectOldImgNode.style.rotate = '0deg'
          selectOldImgNode.style.scale = 1
          selectOldImgNode.style.top = 0
          selectOldImgNode.style.left = 0
        },1000)
      }
      // 切换
      this.defaultAddImgIndex = index
      // store.state.imgZoomIndex
      // this.$store.commit("Img_Zoom_Index", 10)
      // imgIndex
      this.$emit('changeInstanceArrow', this.otherList[index].imgIndex)
      this.$emit('changeArrow', index)
    },
    move(e) {
      let odiv = e.target; //获取目标元素
      console.log(odiv.offsetLeft)
      console.log(odiv.offsetTop)

      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      document.onmousemove = e => {
        //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        // //绑定元素位置到positionX和positionY上面
        // this.positionX = top;
        // this.positionY = left;

        //移动当前元素
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    // moveOne(e) {
    //   let odiv = e.target; //获取目标元素
    //   // console.log(odiv)
    //   // console.log(odiv.offsetLeft)
    //   // console.log(odiv.offsetTop)
    //   // console.log(document.documentElement.clientWidth)

    //   //算出鼠标相对元素的位置
    //   let disX = e.clientX - odiv.offsetLeft;
    //   let disY = e.clientY - odiv.offsetTop;
    //   document.onmousemove = e => {
    //     //鼠标按下并移动的事件
    //     //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
    //     // let left = e.clientX - disX - document.documentElement.clientWidth * 0.5 - 10;
    //     // let top = e.clientY - disY - 198;
    //     let left = e.clientX - disX;
    //     let top = e.clientY - disY;

    //     // //绑定元素位置到positionX和positionY上面
    //     // this.positionX = top;
    //     // this.positionY = left;

    //     // console.log(left)
    //     // console.log(top)

    //     //移动当前元素
    //     odiv.style.left = left + "px";
    //     odiv.style.top = top + "px";
    //   };
    //   document.onmouseup = e => {
    //     document.onmousemove = null;
    //     document.onmouseup = null;
    //   };
    // },
    handleZoomImg(e) {
      // this.isPreview = true;
      // console.log("鼠标滚动了", e);
      e = e || window.event;

      // 火狐下没有wheelDelta，用detail代替，由于detail值的正负和wheelDelta相反，所以取反
      e.delta = e.wheelDelta || -e.detail;

      e.preventDefault();
      if (e.delta > 0) {
        //当滑轮向上滚动时
        this.scaleFunc(2);
      }
      if (e.delta < 0) {
        //当滑轮向下滚动时
        this.scaleFunc(-2);
      }
    },
    // 图片缩放
    scaleFunc(num) {
      // 这里设置了一个缩小倍数限制，最小缩小到0.2呗
      if (this.zoomIndex <= 2 && num < 0) return;
      // this.zoomIndex += num
      this.zoomIndex = this.zoomIndex + num;
      // console.log(this.zoomIndex);
    },
  }
};
</script>
<style lang="less" scoped>
.image-preview-mouse,.image-preview-one {
  display: flex;
  justify-content: center;
  align-items: center;
  // width: 490px;
  height: 100%;
  position: relative; /*定位*/
  // top: -20px;
  top: 0px;
  left: 0px;
}
.rotate-btns {
  text-align: center;
  margin-top: 24px;
}
.instance-img {
  width: 100%;
}
// .file-img {
//   padding: 10px;
// }
.file-pic,.file-img,.file-img-png {
  width: 100%;
  height: 100%;
}
.file-img-png {
  overflow: hidden;
  position: relative;
}
.instance-pic-wrapper {
  padding: 0 10px;
}
.no-img {
  height:100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #FFFFFF;
}
</style>